import { FlexCol } from '@/components/ui/flex';
import { type FC } from 'react';
import { Outlet } from 'react-router';
import { LiteratureReviewHeader } from './components/LiteratureReviewHeader';

export const LiteratureReviewLayout: FC = () => {
  return (
    <FlexCol w="full" h="full" className="overflow-hidden">
      <LiteratureReviewHeader />
      <FlexCol h="full" className="overflow-y-auto">
        <Outlet />
      </FlexCol>
    </FlexCol>
  );
};
